<!-- Alert -->
<div class="alert alert-secondary alert-dismissible fade show text-center" role="alert">
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. <svg class="icon ic-22"><use href="assets/icons/icons-sprite.svg#svg-meteorite"/></svg> <a href="#" class="alert-link">In tempus quis purus</a> eget aliquam. 
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<!-- / Alert -->